export default __webpack_public_path__ + "static/media/del.86ed8276.svg";